import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { COLORS } from '../constants/styles';
import { WarningColorInvertIcon } from '../components/icons/WarningColorInvertIcon';

const Wrapper = styled.div`
    position: relative;
`;
const CodeInput = styled.input<{ showError: boolean }>`
    background-color: transparent;
    height: 50px;
    width: 100%;
    border: 1px solid ${(props) => (props.showError ? COLORS.error : COLORS.grey)};
    border-radius: 5px;
    &:focus {
        outline: none;
    }
    margin: 10px auto;
    padding-left: 8px;
`;

const ValidityAnimation = keyframes`
    0% { transform: translateX(100%); }
    100% { transform: translateX(0); }
`;
const Validity = styled.div`
    position: absolute;
    overflow: hidden;
    top: 25px;
    right: 8px;
    svg {
        animation: ${ValidityAnimation} 0.75s ease;
    }
`;

const VerificationCodeField: React.FC<{
    id: string;
    onInputVerifyCode: (code: string) => void;
    verifyFailed: boolean;
    verifyTimes: number;
}> = ({ id, onInputVerifyCode, verifyFailed, verifyTimes }) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        if (verifyFailed) {
            setValue('');
        }
    }, [verifyFailed, verifyTimes]);

    const processInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const num = e.target.value;
        if (/[^0-9]/.test(num)) return;
        setValue(num);
        onInputVerifyCode(num);
    };

    return (
        <Wrapper>
            <CodeInput
                id={id}
                type="text"
                inputMode="numeric"
                maxLength={8}
                value={value}
                autoFocus
                onChange={processInput}
                showError={verifyFailed}
            />
            <Validity>{verifyFailed && <WarningColorInvertIcon />}</Validity>
        </Wrapper>
    );
};

export default VerificationCodeField;
